import { IContextMenuService } from "../IContextMenuService";
import { ContextMenuItem } from "../../../model/contextmenu/ContextMenuItem";
import { ContextMenuState } from "../../../model/contextmenu/ContextMenuState";
import { ContextMenuServiceResponse } from "../../../model/contextmenu/ContextMenuServiceResponse";

import { BfxBlotterOrdersContextMenuState } from "../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "../../../model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuItem";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const BLOTTER_ORDERS_CONTEXT_MENU_SERVICE: string = "BlotterOrdersContextMenuServiceChannel";

export interface IBlotterOrdersContextMenuService
  extends IContextMenuService<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem> {
  getMenuItems(
    selectedIds: Array<string>,
    menuState: ContextMenuState,
  ): Promise<ContextMenuServiceResponse<CubiqTS.OrderDataImpl, BfxBlotterOrdersContextMenuItem>>;
}
